import React, { Fragment, useEffect } from 'react';
import Calendar from '../../../shared/components/Calendar/Preview';
import CategoryModal from '../CategoryModal';
import ErrorMessage from '../ErrorMessage';
import CloseIcon from '../../../shared/components/Icons/Close';
import MobileHide from '../../../shared/components/MobileHide';
import MobileOverlay from '../MobileOverlay';
import Nav from '../Nav';
import Notifications from '../../../shared/components/Notifications';
import OrderForm from '../OrderForm';
import Popover from '../Popover';
import ReloadOverlay from '../ReloadOverlay';
import Scheme from '../Scheme';
import TableSelector from '../TableSelector';
import TicketsCountModal from '../TicketsCountModal';
import TicketsModal from '../../../shared/components/TicketsModal';
import ViewModeToggle from '../ViewModeToggle';
import Zoom from '../Zoom';
import Styled from '../../../shared/components/Layout/styles';
import GlobalStyles from '../../../styles/global';
import Alerts from '../../../shared/components/Alerts';
import useLayout from '../../../hooks/useLayout';
import { WidgetParameters } from '../../../types/widget';
import Help from '../Help';
import HelpButton from '../HelpButton';
import type { IStateController } from '../../../lib/widget/state/state.interface';
import { useInjection } from 'inversify-react';
import { STATE_MODULE_IDS } from '../../../lib/widget/state/state.types';
import IDS from '../../../constants/IDS';

const Layout = (props: Omit<WidgetParameters, 'node'>) => {
  const stateController: IStateController = useInjection(STATE_MODULE_IDS.STATE_CONTROLLER);
  const { Widget } = window;
  const { poolSettings, settings } = props;

  const { state, showMobileOverlayFC, hideMobileOverlayFC, toggleReloadOverlay } = useLayout();
  const {
    previewMode,
    withoutFullscreen,
    termsUrl,
    personalDataTermsUrl,
    reloadMinutes,
    hideMobileOverlay,
    landingPreivewMode,
  } = settings;
  const {
    showMobileOverlay,
    isFullscreen,
    orderFormIsHidden,
    isFailure,
    reloadOverlayVisible,
    schemeMode,
  } = state;
  const { isPeriodical } = Widget.metaController.meta;

  const mobileOverlayIsVisible =
    !isFailure &&
    orderFormIsHidden &&
    showMobileOverlay &&
    !reloadOverlayVisible &&
    !hideMobileOverlay;

  useEffect(() => {
    if (mobileOverlayIsVisible) {
      stateController.lock();
    }
  }, []);

  return (
    <Styled.Layout id={IDS.rootLayout}>
      <GlobalStyles.Global />
      {landingPreivewMode ? null : isFailure && <ErrorMessage />}
      {mobileOverlayIsVisible && <MobileOverlay onClick={hideMobileOverlayFC} />}
      {!previewMode && !poolSettings && <Nav layoutState={{ ...state, previewMode }} />}
      {isFullscreen && (
        <Styled.CloseButton onClick={showMobileOverlayFC} isPeriodical={isPeriodical}>
          <CloseIcon />
        </Styled.CloseButton>
      )}

      {!previewMode && !isFailure && !showMobileOverlay && (
        <Fragment>
          <ViewModeToggle />
        </Fragment>
      )}

      <Scheme
        previewMode={previewMode}
        isFullscreen={isFullscreen}
        isFailure={isFailure}
        hidden={!schemeMode || !orderFormIsHidden}
        widget={Widget}
      />
      {(landingPreivewMode || (!isFailure && orderFormIsHidden)) && (
        <MobileHide isFullscreen={isFullscreen}>
          <Zoom
            hideZoom={!schemeMode}
            toggleFullscreen={Widget.toggleFullscreen}
            isFullscreen={isFullscreen}
            withoutFullscreen={withoutFullscreen}
          />
        </MobileHide>
      )}

      <MobileHide isFullscreen={isFullscreen}>
        <Alerts />
      </MobileHide>

      {!schemeMode && <TableSelector isFullscreen={isFullscreen} />}

      <MobileHide isFullscreen={isFullscreen}>
        <HelpButton />
      </MobileHide>
      <MobileHide isFullscreen={isFullscreen}>
        <Help />
      </MobileHide>
      {orderFormIsHidden && schemeMode && <Popover />}
      {orderFormIsHidden && <TicketsModal />}
      {!orderFormIsHidden && (
        <OrderForm
          termsUrl={termsUrl}
          personalDataTermsUrl={personalDataTermsUrl}
          isFullscreen={isFullscreen}
        />
      )}
      <Calendar />
      <TicketsCountModal />
      <CategoryModal />
      <MobileHide isFullscreen={isFullscreen}>
        <Notifications />
      </MobileHide>
      {!isFailure && (
        <ReloadOverlay
          reloadMinutes={reloadMinutes}
          toggle={toggleReloadOverlay}
          isVisible={reloadOverlayVisible}
        />
      )}
    </Styled.Layout>
  );
};

export default Layout;
